<ng-template #imageTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Upload Image</h4>
        <button (click)="modalRef?.hide()" aria-label="Close" class="btn-close close pull-right" type="button">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-image-cropper (completed)="uploadComplete()" [aspectRatio]="4 / 3" [fileName]="imageKey" [filePath]="parkingsFilePath" [uid]="merchantKey"></app-image-cropper>
    </div>
</ng-template>

<ng-template #archiveTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Confirmation</h4>
        <button (click)="modalRef?.hide()" aria-label="Close" class="btn-close close pull-right" type="button">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">Are you sure you wish to delete this parking?</div>
    <div class="modal-footer">
        <button (click)="modalRef?.hide()" class="btn btn-outline-secondary" type="button">Cancel</button>
        <button (click)="archiveParking()" class="btn btn-outline-danger" type="button">Delete</button>
    </div>
</ng-template>
<ng-template #publishTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Confirmation</h4>
        <button (click)="modalRef?.hide()" aria-label="Close" class="btn-close close pull-right" type="button">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <span *ngIf="isValid">
            Your parking will be sent for review. You'll be notified by email when it is made available to the public.
            <div class="mt-3">
                <div class="form-check">
                    <input (change)="undertakeCheckboxListener($event)" class="form-check-input" id="undertake" type="checkbox" value="" />
                    <label class="form-check-label" for="undertake"> I agree to check my email and get back to applicants within 24 hours. </label>
                </div>
                <div class="form-check">
                    <input (change)="undertakeCheckboxListener($event)" class="form-check-input" id="commission" type="checkbox" value="" />
                    <label class="form-check-label" for="commission"> I understand that ParkUpp will charge a 15% service fee. </label>
                </div>
                <div class="form-check">
                    <input (change)="termsCheckboxListener($event)" class="form-check-input" id="termsAndConditions" type="checkbox" value="" />
                    <label class="form-check-label" for="termsAndConditions"> I agree to ParkUpp's <a [routerLink]="['/terms-and-conditions']" target="_blank">Terms and Conditions</a> </label>
                </div>
            </div>
        </span>
        <div *ngIf="!isValid" class="alert alert-warning">Please complete the required fields before attempting to publish for review.</div>
        <div *ngIf="!agreeNotSelected" class="alert alert-warning mt-2">Please accept the undertaking and terms before attempting to publish for review.</div>
    </div>
    <div class="modal-footer">
        <button (click)="modalRef?.hide()" class="btn btn-outline-secondary" type="button">Cancel</button>
        <button (click)="publishForReview()" *ngIf="isValid" class="btn btn-outline-primary" type="button">Publish for Review</button>
    </div>
</ng-template>
<ng-template #approveTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Confirmation</h4>
        <button (click)="modalRef?.hide()" aria-label="Close" class="btn-close close pull-right" type="button">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">Are you sure you wish to approve this listing?</div>
    <div class="modal-footer">
        <button (click)="modalRef?.hide()" class="btn btn-outline-secondary" type="button">Cancel</button>
        <button (click)="approveForParking()" *ngIf="isValid" class="btn btn-outline-primary" type="button">Approve</button>
    </div>
</ng-template>
<ng-template #removeImage>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Confirmation</h4>
        <button (click)="modalRef?.hide()" aria-label="Close" class="btn-close close pull-right" type="button">
            <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
    </div>
    <div class="modal-body">Are you sure you wish to delete this image?</div>
    <div class="modal-footer">
        <button (click)="modalRef?.hide()" class="btn btn-outline-secondary" type="button">Cancel</button>
        <button (click)="confirmDeleteImage()" class="btn btn-outline-danger" type="button">Delete</button>
    </div>
</ng-template>
<form (ngSubmit)="onSave()" *ngIf="parking" [formGroup]="formGroup">
    <div class="sticky-buttons p-3">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <button (click)="openDeleteModal(archiveTemplate)" class="btn btn-outline-danger" type="button">Delete</button>
                    <button class="btn btn-primary float-end" type="submit">
                        <i *ngIf="loading" class="fa fa-circle-notch fa-spin"></i>
                        <span *ngIf="!loading && parking.parkingStatus == parkingStatus.NEW">Save Draft</span>
                        <span *ngIf="!loading && parking.parkingStatus != parkingStatus.NEW">Save</span>
                    </button>
                    <button (click)="openPublishModal(publishTemplate)" *ngIf="parking.parkingStatus == parkingStatus.NEW" class="btn btn-outline-info me-2 float-end" type="button">Publish</button>
                    <button
                        (click)="openAdminPublishModal(approveTemplate)"
                        *ngIf="parking.parkingStatus == parkingStatus.PENDING && authService.admin"
                        class="btn btn-outline-primary me-2 float-end"
                        type="button"
                    >
                        Approve
                    </button>
                    <button (click)="preview()" class="btn btn-outline-secondary me-2 float-end" type="button">Preview</button>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="text-center">
                    <div *ngIf="parking && parking.parkingStatus == parkingStatus.PENDING" class="alert alert-warning">
                        <b>Pending Review</b> You will be notified by email when your parking is published
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="text-center">
                    <div *ngIf="parking && parking.parkingStatus == parkingStatus.NEW" class="alert alert-warning">Please complete the required fields before attempting to publish for review.</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h2 class="mb-3">List your parking bay</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group mb-4 d-none">
                    <label>Type <span class="text-danger">*</span></label>
                    <input class="form-control" formControlName="parkingType" id="parkingType" name="parkingType" placeholder="Parking Type" type="text" />
                    <div class="invalid-feedback" invalidMessage="parkingType">{{ formGroup.get('parkingType') | validationErrors }}</div>
                </div>
                <div class="form-group mb-4">
                    <label>Name of Parking <span class="text-danger">*</span></label>
                    <input class="form-control" formControlName="title" id="title" left name="title" parking placeholder="Name of Parking" required spots type="text" />
                    <div class="invalid-feedback" invalidMessage="title">{{ formGroup.get('title') | validationErrors }}</div>
                </div>
                <div class="form-group mb-4">
                    <label>Number of Bays <span class="text-danger">*</span></label>
                    <input class="form-control" formControlName="numberOfBays" id="numberOfBays" name="numberOfBays" placeholder="Number of Bays" required type="number" />
                    <div class="invalid-feedback" invalidMessage="numberOfBays">{{ formGroup.get('numberOfBays') | validationErrors }}</div>
                </div>
                <div class="form-group mb-5">
                    <label>What am I offering <span class="text-danger">*</span> </label>
                    <div>
                        <a (click)="getDescriptionHelp()" class="cursor small text-info"> <i class="fas fa-info-circle cursor"></i> Click to see and example</a>
                    </div>
                    <textarea
                        autosize
                        class="form-control"
                        formControlName="description"
                        id="description"
                        name="description"
                        required
                        rows="4"
                        type="text"
                        placeholder="Description of the parking facility"
                    >
                    </textarea>
                    <div class="invalid-feedback" invalidMessage="description">{{ formGroup.get('description') | validationErrors }}</div>
                </div>

                <div class="form-group mb-5">
                    <label>Contact Information</label>
                    <div><small>Please provide email address and phone number/s for the building manager</small></div>
                    <textarea class="form-control" formControlName="contactInformation" name="contactInformation" placeholder="Contact Information" type="text" rows="3"></textarea>
                </div>

                <div *ngIf="showInputStartDate" class="form-group mb-5">
                    <div class="form-group col-6">
                        <label>Event Date <span class="text-danger">*</span></label>
                        <input class="form-control" formControlName="startDate" name="startDate" type="date" />
                    </div>
                </div>

                <!-- <div class="form-group mb-5">
                    <label>Where I want to be paid</label> <small class="ms-2">(Optional)</small>
                    <div (click)="openBankDetailsModal(bankDetailsListTemplate)" *ngIf="parking && !bankDetails" class="dropzone-wrapper">
                        <div class="dropzone-desc">Add payout information</div>
                    </div>
                    <div *ngIf="parking && bankDetails" class="form-group mb-5">
                        <div class="card mt-3 w-100">
                            <div class="card-body">
                                <h5 class="card-title d-inline-block">{{ bankDetails.accountHolderName }}</h5>
                                <div (click)="openBankDetailsModal(bankDetailsListTemplate)" class="icon-button float-end"><i class="fa fa-edit"></i></div>
                                <h6 class="card-subtitle mb-2 text-muted">{{ bankDetails.bank }} {{ bankDetails.accountNumber }}</h6>
                                <p class="card-text text-muted">{{ bankDetails.billingAddressStreetNumber }} {{ bankDetails.billingAddressStreetAddress }}</p>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <div class="col-md-6">
                <div class="form-group mb-4">
                    <label>Street address <span class="text-danger">*</span></label>
                    <input class="form-control" formControlName="parkingLocation" id="parkingLocation" name="parkingLocation" placeholder="Parking Address" required type="text" />
                    <div class="invalid-feedback" invalidMessage="parkingLocation">{{ formGroup.get('parkingLocation') | validationErrors }}</div>
                </div>
                <div *ngIf="showInputLocationName" class="col-md-12 my-3">
                    <label>Location Name / Description</label>
                    <input class="form-control" formControlName="parkingLocationName" name="parkingLocationName" placeholder="Example: The building across the road" type="text" />
                </div>
                <div *ngIf="autoCompleteInputElement" class="form-group mb-4 map-container">
                    <app-google-map (onLocationChanged)="onChangeLocation($event)" [autoCompleteInputElement]="autoCompleteInputElement" [mapHeight]="mapHeight" [parking]="parking"></app-google-map>
                </div>

                <div class="form-group mb-4">
                    <label>Parking Access Instructions</label>
                    <div><small>Please provide any additional instructions for the parking address including which entrance to use, specific directions, available times, etc</small></div>
                    <textarea
                        class="form-control"
                        formControlName="parkingAddressInstructions"
                        name="parkingAddressInstructions"
                        placeholder="Parking Address Instructions"
                        type="text"
                        rows="3"
                    ></textarea>
                </div>

                <!-- <div class="form-group mb-4">
                    <label>Building Name</label>
                    <br /><small class="ms-2">This field is not required and is used for reporting purposes</small>
                    <input class="form-control" formControlName="buildingName" type="text" />
                </div>

                <div class="form-group mb-4">
                    <label>Manager Name</label>
                    <br /><small class="ms-2">This field is not required and is used for reporting purposes</small>
                    <input class="form-control" formControlName="managerName" type="text" />
                </div>

                <div class="form-group mb-4">
                    <label>Whitelabel Name</label>
                    <br /><small class="ms-2">This field is not required and is used for reporting purposes</small>
                    <input class="form-control" formControlName="whiteLabelName" type="text" />
                </div> -->
            </div>
        </div>

        <div *ngIf="this.parking.parkingType != ParkingType.BOOKING" class="row">
            <div class="col-12">
                <div class="divider mb-5"></div>
            </div>
        </div>
        <div *ngIf="this.parking.parkingType != ParkingType.BOOKING" class="row">
            <div class="col-12">
                <h2>Pricing</h2>
            </div>
        </div>
        <div class="row">
            <div *ngIf="availablePlans.includes(Term.ONCEOFF)" class="col-md-6">
                <div class="form-group mb-4">
                    <label>Once Off Fee <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <div class="input-group-text"><strong>R</strong></div>
                        <input class="form-control" formControlName="onceOffFee" id="onceOffFee" inputCurrency name="onceOffFee" placeholder="R" type="text" />
                    </div>
                    <div class="invalid-feedback" invalidMessage="description">{{ formGroup.get('onceOffFee') | validationErrors }}</div>
                </div>
            </div>

            <div *ngIf="availablePlans.includes(Term.DAILY)" class="col-md-6" id="dailyFee">
                <div class="form-group mb-4">
                    <label>Daily Fee <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <div class="input-group-text"><strong>R</strong></div>
                        <input class="form-control" formControlName="dailyFee" id="dailyFeeInput" inputCurrency name="dailyFee" placeholder="R" type="text" />
                    </div>
                    <div class="invalid-feedback" invalidMessage="description">{{ formGroup.get('dailyFee') | validationErrors }}</div>
                </div>
            </div>

            <div *ngIf="availablePlans.includes(Term.MONTHLY)" class="col-md-6" id="monthlyFee">
                <div class="form-group mb-4">
                    <label>Monthly Fee (Including VAT)<span class="text-danger">*</span></label>
                    <div class="input-group">
                        <div class="input-group-text"><strong>R</strong></div>
                        <input class="form-control" formControlName="monthlyFee" id="monthlyFeeInput" inputCurrency name="monthlyFee" placeholder="R" type="text" />
                    </div>
                    <div class="invalid-feedback" invalidMessage="description">{{ formGroup.get('monthlyFee') | validationErrors }}</div>
                </div>
            </div>

            <div *ngIf="availablePlans.includes(Term.FLEX_MONTH)" class="col-md-6">
                <div class="form-group mb-4">
                    <label>Full Month Fee <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <div class="input-group-text"><strong>R</strong></div>
                        <input class="form-control" formControlName="flexMonth" inputCurrency name="flexMonth" placeholder="R" type="text" />
                    </div>
                    <div class="invalid-feedback" invalidMessage="description">{{ formGroup.get('flexMonth') | validationErrors }}</div>
                </div>
            </div>

            <div *ngIf="availablePlans.includes(Term.FLEX_HALF_MONTH)" class="col-md-6">
                <div class="form-group mb-4">
                    <label>Half Month Fee (Optional)</label><br />
                    <small>Set this to R0 to disallow the half month option.</small>
                    <div class="input-group">
                        <div class="input-group-text"><strong>R</strong></div>
                        <input class="form-control" formControlName="flexHalfMonth" inputCurrency name="flexHalfMonth" placeholder="R" type="text" />
                    </div>
                    <div class="invalid-feedback" invalidMessage="description">{{ formGroup.get('flexHalfMonth') | validationErrors }}</div>
                </div>
            </div>

            <!-- <div *ngIf="showDailyDiscount" class="col-md-6" id="">
                <div class="form-group mb-4">
                    <label>Comparison Daily Rate (Optional)</label><br />
                    <small>This optional field is used to show the savings</small>
                    <div class="input-group">
                        <div class="input-group-text"><strong>R</strong></div>
                        <input class="form-control" formControlName="dailySavings" id="dailySavings" inputCurrency name="dailySavings" placeholder="R" type="text" />
                    </div>
                </div>
            </div> -->
        </div>
        <div *ngIf="this.parking.parkingType != ParkingType.BOOKING" class="row">
            <div class="col-12">
                <div class="divider my-5"></div>
            </div>
        </div>
        <div *ngIf="this.parking.parkingType != ParkingType.BOOKING" class="row">
            <div class="col-12 mb-4">
                <h2 class="mb-0">Features</h2>
                <small>(Optional - Click to select)</small>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-5">
                <ng-container *ngFor="let amenity of amenitiesList">
                    <ng-container>
                        <button btnCheckbox class="p-2 me-3 btn btn-outline-primary" formControlName="{{ amenity.key }}" id="{{ amenity.key }}" type="button">
                            {{ typeSpecificAmenities[amenity.key] }}
                        </button>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="divider mb-5"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <h2 class="mb-0">Gallery</h2>
                <small class="">Include images that showcase the outside of the building.</small>
                <br />
                <small class="text-danger">(At least one is required)</small>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-2 col-lg-3 col-md-4 col-6">
                <div (click)="openImageModal(imageTemplate)" class="dropzone-wrapper">
                    <div class="dropzone-desc">
                        <i class="fa fa-upload"></i>
                        Upload Image
                    </div>
                </div>
            </div>
            <div *ngIf="uploading" class="col-xl-2 col-lg-3 col-md-4 col-6 position-relative">
                <img alt="Profile" class="w-100 rounded-image mb-3" src="/assets/images/parking/no_image.png" />
                <div class="image-load-container">
                    <div><small>Processing</small></div>
                    <div><i class="fa fa-circle-notch fa-spin mt-2"></i></div>
                </div>
            </div>
            <div *ngFor="let image of parkingImages" class="col-xl-2 col-lg-3 col-md-4 col-6 position-relative">
                <ng-container *ngIf="image.smallUrl">
                    <img alt="Profile" class="w-100 rounded-image mb-3" src="{{ image.smallUrl }}" />
                    <button aria-expanded="true" class="icon-button primary-image-button" data-bs-toggle="dropdown" data-toggle="dropdown" id="dropdownImageMenu" type="button">
                        <i class="fa fa-bars"></i>
                    </button>
                    <div aria-labelledby="dropdownImageMenu" class="dropdown-menu">
                        <li><a (click)="makeImagePrimary(image)" class="dropdown-item" href="">Make Primary</a></li>
                        <li><a (click)="deleteImage(image, removeImage)" class="dropdown-item" href="">Delete</a></li>
                    </div>
                </ng-container>
                <ng-container *ngIf="!image.smallUrl">
                    <img alt="Profile" class="w-100 rounded-image mb-3" src="/assets/images/parking/no_image.png" />
                    <div class="image-load-container">
                        <div><small>Processing</small></div>
                        <div><i class="fa fa-circle-notch fa-spin mt-2"></i></div>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="divider"></div>

        <div class="row my-5">
            <div class="col-12 mb-4">
                <h3 class="mb-0">Parking Use Policy and Terms</h3>
                <small>
                    The parker will agree to this agreement before initiating a booking request. We strongly recommend that provide a use policy and terms.
                    <br />
                    <!-- If you don't have an agreement, you can use one of the templates below. Simply click to download, adjust it as needed,
                    <div>
                        <a href="/assets/terms/Template%20Landlord%20Terms%201%20-%20Basic.docx" class="badge text-white bg-info me-2" target="_blank">Template 1 - Standard Agreement</a>
                        <a href="/assets/terms/Template%20Landlord%20Terms%202%20-%20ID%20Required%20+%20Deposit.docx" class="badge text-white bg-info me-2" target="_blank">
                            Template 2 - Standard + ID Required & Deposit Required
                        </a>
                        <a href="/assets/terms/Template%20Landlord%20Terms%203%20-%20Lease%20Required.docx" class="badge text-white bg-info me-2" target="_blank"
                            >Template 3 - Agreement with Lease Required</a
                        >
                    </div> -->
                </small>
            </div>
            <div *ngIf="parking && parking.usePolicyUrl" class="col-12">
                <ul class="list-group mb-2">
                    <li class="list-group-item">
                        <a href="{{ parking.usePolicyUrl }}" target="_blank"> <i class="fa fa-file-text mr-2"></i> Current Parking Use Policy and Terms </a>
                    </li>
                </ul>
            </div>
            <div class="col-12">
                <label class="btn file-upload-button" [ngClass]="{ 'btn-loading disabled': serviceAgreementLoading }" title="Upload file">
                    <input (change)="selectAndUploadContract($event)" [disabled]="serviceAgreementLoading" accept="*" class="hide" name="file" type="file" />
                    <i *ngIf="!serviceAgreementLoading" class="fa fa-folder-open"></i>
                    <i *ngIf="serviceAgreementLoading" class="fa fa-circle-o-notch fa-spin"></i>
                    {{ serviceAgreementLoading ? 'Uploading...' : 'Attach Parking Use Policy and Terms' }}
                </label>
            </div>
        </div>

        <div class="divider"></div>

        <div class="row my-5">
            <div class="col-12 mb-4">
                <h2 class="mb-0">Formal Lease Agreement <span class="small"> (Optional)</span></h2>
                <small>
                    This will be emailed to the parker and they will be required to sign it and email it back.
                    <br />
                    <!-- If you don't have an agreement, you can use the template below. Simply click to download, adjust it as needed, -->
                    <!-- <div> -->
                    <!-- <a href="/assets/terms/Template Lease Agreement.docx" class="badge text-white bg-info me-2" target="_blank">Template Lease Agreement</a> -->
                    <!-- </div> -->
                </small>
            </div>
            <div *ngIf="parking && parking.leaseAgreementUrl" class="col-12">
                <ul class="list-group mb-2">
                    <li class="list-group-item">
                        <a href="{{ parking.leaseAgreementUrl }}" target="_blank"> <i class="fa fa-file-text mr-2"></i> Current Lease Agreement </a>
                    </li>
                </ul>
            </div>
            <div class="col-12">
                <label class="btn file-upload-button" [ngClass]="{ 'btn-loading disabled': leaseAgreementLoading }" title="Upload file">
                    <input (change)="selectAndUploadLeaseAgreement($event)" [disabled]="leaseAgreementLoading" accept="*" class="hide" name="file" type="file" />
                    <i *ngIf="!leaseAgreementLoading" class="fa fa-folder-open"></i>
                    <i *ngIf="leaseAgreementLoading" class="fa fa-circle-o-notch fa-spin"></i>
                    {{ leaseAgreementLoading ? 'Uploading...' : 'Attach Lease Agreement' }}
                </label>
            </div>
        </div>

        <div class="divider"></div>

        <div class="row my-5">
            <div class="col-12">
                <div class="col-12">
                    <h3 class="mb-0">Information for the parker <span class="text-danger">*</span></h3>
                    <p>Please include some notes and information that will be emailed to the parker when a parking contract is started. Example: Deposit details, phone numbers etc.</p>
                    <div class="form-group mb-5">
                        <textarea class="form-control" formControlName="parkerInformation" id="parkerInformation" name="description" placeholder="Description" rows="4"> </textarea>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="authService.admin" class="row mt-5">
            <div class="col-12">
                <div class="divider mb-5"></div>
                <div class="col-12">
                    <h5>Admin Details</h5>
                    <small>These fields are only visible to ParkUpp website Admins</small>
                    <div class="form-group">
                        <input class="" formControlName="admytLpr" id="admytLpr" name="admytLpr" type="checkbox" />&nbsp;
                        <label for="admytLpr">Admyt LPR badge</label>
                    </div>
                    <!--                    <div class="form-group">-->
                    <!--                        <input type="checkbox" name="admytQr" id="admytQr"-->
                    <!--                               formControlName="admytQr" class="" />&nbsp;-->
                    <!--                        <label for="admytQr">Admyt QR badge</label>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</form>
